var BaseElementView = require( 'kitbuilder-views/base-element' ),
	WidgetView;

WidgetView = BaseElementView.extend( {
	_templateType: null,

	getTemplate: function() {
		var editModel = this.getEditModel();

		if ( 'remote' !== this.getTemplateType() ) {
			return Marionette.TemplateCache.get( '#tmpl-kitbuilder-' + editModel.get( 'elType' ) + '-' + editModel.get( 'widgetType' ) + '-content' );
		} else {
			return _.template( '' );
		}
	},

	className: function() {
		return BaseElementView.prototype.className.apply( this, arguments ) + ' kitbuilder-widget';
	},

	events: function() {
		var events = BaseElementView.prototype.events.apply( this, arguments );

		events.click = 'onClickEdit';

		return events;
	},

	initialize: function() {
		BaseElementView.prototype.initialize.apply( this, arguments );

		var editModel = this.getEditModel();

		editModel.on( {
			'before:remote:render': _.bind( this.onModelBeforeRemoteRender, this ),
			'remote:render': _.bind( this.onModelRemoteRender, this )
		} );

		if ( 'remote' === this.getTemplateType() && ! this.getEditModel().getHtmlCache() ) {
			editModel.renderRemoteServer();
		}
	},

	render: function() {
		if ( this.model.isRemoteRequestActive() ) {
			this.handleEmptyWidget();

			this.$el.addClass( 'kitbuilder-element' );

			return;
		}

		Marionette.CompositeView.prototype.render.apply( this, arguments );
	},

	handleEmptyWidget: function() {
		// TODO: REMOVE THIS !!
		// TEMP CODING !!
		this.$el
			.addClass( 'kitbuilder-widget-empty' )
			.append( '<i class="kitbuilder-widget-empty-icon ' + this.getEditModel().getIcon() + '"></i>' );
	},

	getTemplateType: function() {
		if ( null === this._templateType ) {
			var editModel = this.getEditModel(),
				$template = Backbone.$( '#tmpl-kitbuilder-' + editModel.get( 'elType' ) + '-' + editModel.get( 'widgetType' ) + '-content' );

			this._templateType = $template.length ? 'js' : 'remote';
		}

		return this._templateType;
	},

	onModelBeforeRemoteRender: function() {
		this.$el.addClass( 'kitbuilder-loading' );
	},

	onBeforeDestroy: function() {
		// Remove old style from the DOM.
		kitbuilder.$previewContents.find( '#kitbuilder-style-' + this.model.cid ).remove();
	},

	onModelRemoteRender: function() {
		if ( this.isDestroyed ) {
			return;
		}

		this.$el.removeClass( 'kitbuilder-loading' );
		this.render();
	},

	getHTMLContent: function( html ) {
		var htmlCache = this.getEditModel().getHtmlCache();

		return htmlCache || html;
	},

	attachElContent: function( html ) {
		var htmlContent = this.getHTMLContent( html ),
			el = this.$el[0];

		_.defer( function() {
			kitbuilderFrontend.getScopeWindow().jQuery( el ).html( htmlContent );
		} );

		return this;
	},

	onClickEdit: function( event ) {
		if ( Backbone.$( event.target ).closest( '.kitbuilder-event-save-default' ).length ) {
			return;
		}

		BaseElementView.prototype.onClickEdit.apply( this, arguments );
	},

	onRender: function() {
        var self = this,
	        editModel = self.getEditModel(),
	        skinType = editModel.getSetting( '_skin' ) || 'default';

        self.$el
	        .attr( 'data-element_type', editModel.get( 'widgetType' ) + '.' + skinType )
            .removeClass( 'kitbuilder-widget-empty' )
	        .addClass( 'kitbuilder-widget-' + editModel.get( 'widgetType' ) + ' kitbuilder-widget-can-edit' )
            .children( '.kitbuilder-widget-empty-icon' )
            .remove();

		// TODO: Find better way to detect if all images are loaded
		_.defer( function() {
			self.$el.imagesLoaded().always( function() {
				setTimeout( function() {
					if ( 1 > self.$el.height() ) {
						self.handleEmptyWidget();
					}
				}, 200 );
				// Is element empty?
			} );
		} );
	}
} );

module.exports = WidgetView;
